/**
 * Order-by for Unstructured Subdatapoint recommendations.
 */
export enum UnstructuredSubDataPointRecommendationOrderField {
  /** Name. */
  Name = 'name',
}
